import { render, staticRenderFns } from "./SpqTipsDialog.vue?vue&type=template&id=3c85f362&scoped=true&"
import script from "./SpqTipsDialog.vue?vue&type=script&lang=ts&"
export * from "./SpqTipsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SpqTipsDialog.vue?vue&type=style&index=0&id=3c85f362&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85f362",
  null
  
)

export default component.exports